import { Component, OnInit } from '@angular/core';
import { AcaDataReportService } from './acaDataReport.service';
import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts } from 'angular-2-dropdown-multiselect';

@Component({
    moduleId: module.id,
    templateUrl: 'acaDataReport.html'

})
export class AcaDataReportComponent implements OnInit {

    dataLoaded: boolean;
    selectedSourceCode: string[];
    selectedEmployerName: string[];
    selectedControlGroup: string[];
    employeeName: string;
    hoursPaid: string;

    public rows: Array<any> = [];
    public page = 1;
    public itemsPerPage = 10;
    public maxSize = 5;
    public numPages = 1;
    public length = 0;

    optionsModel: number[];

    myOptionsEmployerName: IMultiSelectOption[];
    myOptionsCG: IMultiSelectOption[];
    myOptionsSourceCode: IMultiSelectOption[];

    mySettings: IMultiSelectSettings = {
        enableSearch: false,
        showCheckAll: true,
        showUncheckAll: true,
        checkedStyle: 'checkboxes',
        buttonClasses: 'btn btn-default btn-block',
        dynamicTitleMaxItems: 1,
        displayAllSelectedText: false
    };

    // Text configuration
    myTexts: IMultiSelectTexts = {
        checkAll: 'Select all',
        uncheckAll: 'Unselect all'
    };

    public columns: Array<any> = [
        { title: 'Controlled Group Name', className: 'va-m', name: 'controlGroupName' },
        { title: 'Employer Name', className: 'va-m', name: 'employerName' },
        { title: 'Employer Federal TaxID', className: 'va-m', name: 'employerFederalTaxID' },
        { title: 'Employee SSN', className: 'va-m', name: 'ssn' },
        { title: 'Employee Last Name', className: 'va-m', name: 'employeeLastName' },
        { title: 'Employee First Name', className: 'va-m', name: 'employeeFirstName' },
        { title: 'HRS SourceCode', className: 'va-m', name: 'sourceCode' },
        { title: 'Hours Paid', className: 'va-m', name: 'hoursPaid' },
        { title: 'FirstPay Period StartDate', className: 'va-m', name: 'firstPayPeriodStartDate' },
        { title: 'ACA Employment Status', className: 'va-m', name: 'employmentStatus' },
        { title: 'ACA Employment Status', className: 'va-m', name: 'acaEmploymentStatus' },
        { title: 'Benefits Enrollment Status', className: 'va-m', name: 'benefitsEnrollmentStatus' },
        { title: 'HRS Filename', className: 'va-m', name: 'hrsFilename' },
        { title: 'INS Filename', className: 'va-m', name: 'insFilename' }
    ];

    public config: any = {
        paging: true,
        sorting: { columns: this.columns },
        filtering: { filterString: '' },
        className: ['table', 'table-striped', 'table-bordered', 'table-hover']
    };

    empDetails: Array<any> = [];
    errorMessage: string;
    constructor(private _acaDataReportService: AcaDataReportService) { }

    ngOnInit(): void {
        this.myOptionsEmployerName = [];
        this.myOptionsCG = [];
        this.myOptionsSourceCode = [];
        //this.employeeName = '';
        //this.hoursPaid = '';
        this._acaDataReportService.getReportReferenceData().subscribe(data => {

             data.ControlGroup.forEach(element => {
                this.myOptionsCG.push({ id: element, name: element })
            });

            data.EmployerNames.forEach(element => {
                this.myOptionsEmployerName.push({ id: element, name: element })
            });

            data.SourceCodes.forEach(element => {
                this.myOptionsSourceCode.push({ id: element, name: element })
            });
        },
            error => this.errorMessage = <any>error);
    }


    reset(): void {
        this.selectedEmployerName = [];
        this.selectedControlGroup = [];
        this.selectedSourceCode = [];
        this.employeeName = '';
        this.hoursPaid = '';
        this.dataLoaded = false;
    }

    getFilterValues(): any {
      
        let empYear = this.selectedEmployerName;
        if (empYear === undefined) {
            empYear = [];
            empYear[0] = '\'\'';
            this.selectedEmployerName = [];
        }
        if (empYear !== undefined && empYear.length <= 0) {
            empYear[0] = '\'\'';
            this.selectedEmployerName = [];
        }

        let cg = this.selectedControlGroup;
        if (cg === undefined) {
            cg = [];
            cg[0] = '\'\'';
            this.selectedControlGroup = [];
        }
        if (cg !== undefined && cg.length <= 0) {
            cg[0] = '\'\'';
            this.selectedControlGroup = [];
        }

         let srcCode = this.selectedSourceCode;
        if (srcCode === undefined) {
            srcCode = [];
            srcCode[0] = '\'\'';
            this.selectedSourceCode = [];
        }
        if (srcCode !== undefined && srcCode.length <= 0) {
            srcCode[0] = '\'\'';
            this.selectedSourceCode = [];
        }

        let empName = this.employeeName;
        if (empName === undefined || empName === '') {
            empName = '\'\'';
         }

         let hrsPaid = this.hoursPaid;
        if (hrsPaid === undefined || hrsPaid === '') {
            hrsPaid = '\'\'';
        }

        let filterCriteria: any = {
            selectedEmployerName: empYear.join(':'),
            selectedControlGroup: cg.join(':'),
            selectedSourceCode: srcCode.join(':'),
            employeeName: empName,
            employeeHoursPaid: hrsPaid
        };

        return filterCriteria;
    }

    AcaDataReportsData(): void {
        const filterCriteria = this.getFilterValues();
        this._acaDataReportService.getAcaDataReports(filterCriteria).subscribe(empdetails => {
            this.empDetails = empdetails;
            this.onChangeTable(this.config);
            this.dataLoaded = true;
        },
            error => this.errorMessage = <any>error);

    }

    Search(): void {
        this.dataLoaded = false;
        this.AcaDataReportsData();
    }

    downloadPdf(): void {
    }

    downloadExcel(): void {
        const filterCriteria = this.getFilterValues();
        this._acaDataReportService.downloadExcelReport(filterCriteria);
    }
    public changeSort(data: any, config: any): any {
        if (!config.sorting) {
            return data;
        }

        const columns = this.config.sorting.columns || [];
        let columnName: string = void 0;
        let sort: string = void 0;

        for (let i = 0; i < columns.length; i++) {
            if (columns[i].sort !== '' && columns[i].sort !== false) {
                columnName = columns[i].name;
                sort = columns[i].sort;
            }
        }

        if (!columnName) {
            return data;
        }

        // simple sorting
        return data.sort((previous: any, current: any) => {
            if (previous[columnName] > current[columnName]) {
                return sort === 'desc' ? -1 : 1;
            } else if (previous[columnName] < current[columnName]) {
                return sort === 'asc' ? -1 : 1;
            }
            return 0;
        });
    }

    public onChangeTable(config: any, page: any = { page: this.page, itemsPerPage: this.itemsPerPage }): any {
        if (config.filtering) {
            Object.assign(this.config.filtering, config.filtering);
        }

        if (config.sorting) {
            Object.assign(this.config.sorting, config.sorting);
        }

        const filteredData = this.changeFilter(this.empDetails, this.config);
        const sortedData = this.changeSort(filteredData, this.config);
        this.rows = page && config.paging ? this.changePage(page, sortedData) : sortedData;
        this.length = sortedData.length;
    }

    public changeFilter(data: any, config: any): any {
        let filteredData: Array<any> = data;
        this.columns.forEach((column: any) => {
            if (column.filtering) {
                filteredData = filteredData.filter((item: any) => {
                    return item[column.name].match(column.filtering.filterString);
                });
            }
        });

        if (!config.filtering) {
            return filteredData;
        }

        if (config.filtering.columnName) {
            return filteredData.filter((item: any) =>
                item[config.filtering.columnName].match(this.config.filtering.filterString));
        }

        const tempArray: Array<any> = [];
        filteredData.forEach((item: any) => {
            let flag = false;
            this.columns.forEach((column: any) => {
                if (item[column.name] == null) {
                    item[column.name] = '';
                }
            });
            this.columns.forEach((column: any) => {
                if (item[column.name].toString().match(this.config.filtering.filterString)) {
                    flag = true;
                }
            });
            if (flag) {
                tempArray.push(item);
            }
        });
        filteredData = tempArray;

        return filteredData;
    }

    public changePage(page: any, data: Array<any> = this.empDetails): Array<any> {
        const start = (page.page - 1) * page.itemsPerPage;
        const end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;
        return data.slice(start, end);
    }

}



// WEBPACK FOOTER //
// ./src/app/AcaDataReport/acaDataReport.component.ts